<template>
  <div>
    <div class="loader-overlay" v-if="this.$store.state.caller.isLoading">
      <div class="app-loader">
        <span class="loader"></span>
      </div>
    </div>
    <div class="page-header clear-filter" filter-color="orange">
      <parallax
        class="page-header-image"
        style="background-image:url('https://bucket-ctcloud.s3.sa-east-1.amazonaws.com/header-main.webp')"
      >
      </parallax>
      <div class="container-fluid row m-0 align-items-center"
        style="height: 100%;">
        <div class="content-center brand col-12 col-xl-8 mt-xm-5">
          
          <h1 class="h1-seo d-none d-sm-block">Cloud CT</h1>
          <h1 class="d-none d-sm-block">Consultoria em <br />serviços de nuvem. <br />Treinamentos em <br />tecnologia.</h1>
          <h3 class="d-block d-sm-none text-center pt-5">Consultoria em <br />serviços de nuvem. <br />Treinamentos em <br />tecnologia.</h3>
        </div>
        <form-contact></form-contact>
        <!-- <h6 class="category category-absolute text-center">
          Saiba mais
        </h6> -->
      </div>
      
    </div>
    <overview></overview>    
    <portfolio></portfolio>
    <articles></articles>
    <hello></hello>
    <courses></courses>
    <more></more>
  </div> 
</template>

<script>
  import { Parallax } from '@/components';
  // import TabsSection from './components/Tabs';
  import FormContact from './components/FormContact';
  import Overview from './components/Overview';
  // import HelloTraining from './components/HelloTraining';
  import Articles from './components/Articles';
  import Portfolio from './components/Portfolio';
  import Hello from './components/Hello';
  import Courses from './components/Courses';
  import More from './components/More';

  export default {
    name: 'index-page',
    bodyClass: 'index-page',

    components: {
      Courses,
      FormContact,
      Articles,
      More,
      Overview,
      Parallax,
      Hello,
      Portfolio
    },
  }
</script>

<style scoped lang="scss">

.loader-overlay {
  position: fixed;
  background: rgba(0,0,0,0.3);
  z-index: 100;  
  width: 100%;
  height: 100%;
  transition: display 0.2s;

  .app-loader {
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

}



.loader {
  width: 175px;
  height: 80px;
  display: block;
  margin:auto;
  background-image: radial-gradient(circle 25px at 25px 25px, #FFF 100%, transparent 0), radial-gradient(circle 50px at 50px 50px, #FFF 100%, transparent 0), radial-gradient(circle 25px at 25px 25px, #FFF 100%, transparent 0), linear-gradient(#FFF 50px, transparent 0);
  background-size: 50px 50px, 100px 76px, 50px 50px, 120px 40px;
  background-position: 0px 30px, 37px 0px, 122px 30px, 25px 40px;
  background-repeat: no-repeat;
  position: relative;
  box-sizing: border-box;
}
.loader::before {
  content: '';  
  left: 60px;
  bottom: 18px;
  position: absolute;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #FF3D00;
  background-image: radial-gradient(circle 8px at 18px 18px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 18px 0px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 0px 18px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 36px 18px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 18px 36px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 30px 5px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 30px 5px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 30px 30px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 5px 30px, #FFF 100%, transparent 0), radial-gradient(circle 4px at 5px 5px, #FFF 100%, transparent 0);
  background-repeat: no-repeat;
  box-sizing: border-box;
  animation: rotationBack 3s linear infinite;
}
.loader::after {
  content: '';  
  left: 94px;
  bottom: 15px;
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FF3D00;
  background-image: radial-gradient(circle 5px at 12px 12px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 12px 0px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 0px 12px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 24px 12px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 12px 24px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 20px 3px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 20px 3px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 20px 20px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 3px 20px, #FFF 100%, transparent 0), radial-gradient(circle 2.5px at 3px 3px, #FFF 100%, transparent 0);
  background-repeat: no-repeat;
  box-sizing: border-box;
  animation: rotationBack 4s linear infinite reverse;
}

@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

</style>
